import { Box, Typography } from "@mui/material";
import React from "react";

interface BaseToolResultProps {
  icon: string;
  children: React.ReactNode;
}

export const BaseToolResult: React.FC<BaseToolResultProps> = ({
  icon,
  children,
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontSize: "1.2rem", lineHeight: 1 }}>
          {icon}
        </Typography>
        <Box sx={{ flex: 1 }}>{children}</Box>
      </Box>
    </Box>
  );
};
